import { AddIntegrations, MyIntegrations } from 'components/integrations';
import { useLayoutEffect } from 'react';
import { useHistory } from 'react-router';
import { loadLocalStorage, usePageTitle } from 'utils';
import { useQuery } from 'utils/useQuery';

export const IntegrationsPage = () => {
  usePageTitle('Integrations | Segments');
  const history = useHistory();
  const query = useQuery();
  const reconnect = query.get('reconnect');

  // Check if it has 'connect' which means open connect provider modal (returning from OAUTH) and if it is during the onboarding flow, redirect the user back to the flow
  useLayoutEffect(() => {
    const isConnectPath = history.location.pathname.includes('connect');

    // hardcoded as the onboarding flow context is not available in the integration page
    const isOnboardingFlow = loadLocalStorage('segments_onboarding');

    if (isConnectPath && isOnboardingFlow) {
      history.replace({
        ...history.location,
        state: {
          background: {
            ...history.location,
            pathname: '/onboarding/auto_sync',
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    if (reconnect !== null) {
      history.replace({
        pathname: `/integrations/connect/${reconnect}`,
        search: new URLSearchParams({
          store_name: query.get('store_name') || '',
        }).toString(),
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="relative max-w-screen-xl px-5 mx-auto md:pl-segments-72px md:pr-20 py-11">
      <p className="font-bold leading-6">Integrations</p>
      <MyIntegrations />
      <AddIntegrations />
    </div>
  );
};
